












import Vue from 'vue';
import type { PropOptions } from 'vue';
import WarRoomAvatar from '@/components/partials/war-room/WarRoomAvatar.vue';
import HeaderMenuNotificationsCardGrid from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGrid.vue';
import HeaderMenuNotificationsCardGridAvatar from '~/components/global/HeaderMenu/HeaderMenuNotifications/HeaderMenuNotificationsCard/HeaderMenuNotificationsCardGrid/HeaderMenuNotificationsCardGridAvatar/HeaderMenuNotificationsCardGridAvatar.vue';
import type { Notification } from '~/types/graphql';

export default Vue.extend({
  name: 'HeaderMenuNotificationsCardContributionReward',
  components: {
    HeaderMenuNotificationsCardGrid,
    HeaderMenuNotificationsCardGridAvatar,
    WarRoomAvatar,
  },
  props: {
    notification: {
      type: Object,
      required: true,
    } as PropOptions<Notification>,
  },
});
